import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";
import classNames from "classnames";

//CUSTOM COMPONENT
import CardReporting from "../../aGlobalDesign/Reporting/CardReporting";
import IconComponent from "../../aGlobalDesign/Icons/IconComponent";
import Loader from "../../aGlobalDesign/Loader/Loader";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import Drawer from "../../aGlobalDesign/Modal/Drawer";

// Disable date after today on date picker
const currentDate = new Date();
const tomorrow = new Date(currentDate);
tomorrow.setDate(currentDate.getDate() + 1);
const dateInOneYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
const disabledDays = [
    { from: tomorrow, to: dateInOneYear }
];

class DashboardAgents extends React.Component {

    constructor() {
        super();
        const end = new Date();
        const start = new Date();
        start.setUTCDate(start.getUTCDate() - 7);
        this.state = {
            dateSelected: {
                // 7 days before today
                "Start date": start.toISOString().slice(0, 19).replace("T", " "),
                // Today
                "End date": end.toISOString().slice(0, 19).replace("T", " ")
            },
            results: null,
            listResults: null,
            forcePaginationUpdate: 0
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle("dashboardAgents");
        this.props.ChangeCurrentMenuName("dashboardAgents");
    }
    componentDidUpdate(prevProps) {
        const reload = this.props.reload;
        if (reload && this.props.reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            openModal: 0,
            forcePaginationUpdate: temp
        });
    }
    GetNewReporting(dateSTart, dateEnd, zoneId, callCenterId, onSuccess) {
        this.setState({ listResults: null });
        this.props.onRequestStatisticsAgents(callCenterId, zoneId, dateSTart, dateEnd, (data) => {
            console.log("reporting - success", { dateStart: dateSTart, dateEnd: dateEnd, data: data });
            onSuccess(data);
        });
    }
    GetNewReportingForAgent(agentId, agentName) {
        this.setState({ results: { state: "loading", name: agentName } });
        const callCenterId = this.props.callcenterSelected ? this.props.callcenterSelected.id : null;
        const zoneId = this.props.zoneSelected ? this.props.zoneSelected.id : null;
        const dateStart = this.props.dateSelected["Start date"];
        const dateEnd = this.props.dateSelected["End date"];
        this.props.onRequestStatisticsForAgent(callCenterId, zoneId, dateStart, dateEnd, agentId, (data) => {
            console.log("agent reporting - success", { dateStart: dateStart, dateEnd: dateEnd, data: data });
            this.setState({ results: { state: "done", name: agentName, data: data } });
        });
    }

    getNotesArray(arrayReview, totalReview) {
        const result = [];
        let notedCalls = 0;
        const hn = { note: "5", quantity: 0 };
        for (let i = 5; i > 0; i--) {
            const review = arrayReview.find(obj => Number(obj.name) === i);
            if (!review) {
                result.push({ note: i.toString(), quantity: 0 });
            }
            else {
                notedCalls += review.count;
                if (review.count > hn.quantity) {
                    hn.note = review.name;
                    hn.quantity = review.count;
                }
                result.push({ note: review.name, quantity: review.count });
            }
        }
        if (totalReview !== null) {
            const noNote = { note: null, quantity: totalReview ? totalReview - notedCalls : 0 };
            if (noNote.quantity > hn.quantity) {noNote.isHighest = true;}
            else {
                result.find(obj => obj.note === hn.note).isHighest = true;
            }
            result.push(noNote);
        }
        return result;
    }

    addDays(date, days) {
        date.setDate(date.getDate() + days);
        return date;
    }

    getDatesArray(arrayDates, addsubdatas) {
        const result = [];
        const subsections = [];
        const datestart = new Date(this.state.dateSelected["Start date"]);
        const dateend = this.addDays(new Date(this.state.dateSelected["End date"]), 1);
        let curDate = datestart;
        const oneDate = arrayDates.length === 0 || format(new Date(arrayDates[0].name), "yyyy-MM-dd") === format(new Date(arrayDates[arrayDates.length - 1].name), "yyyy-MM-dd");
        arrayDates.forEach(d => {
            if (!subsections.includes(d.subtitle)) {
                subsections.push(d.subtitle);
            }
        });

        while (format(curDate, "yyyy-MM-dd") !== format(dateend, "yyyy-MM-dd")) {
            const obj = {
                name: format(curDate, "yyyy-MM-dd"),
                short: oneDate ? format(curDate, "dd.MM") : format(curDate, "dd"),
                subdatas: addsubdatas ? {} : null
            };
            subsections.forEach(s => {
                const data = arrayDates.find(dt => dt.subtitle === s && dt.name === format(curDate, "yyyy-MM-dd"));
                if (data !== undefined) {
                    obj[s] = data.count;
                    if (addsubdatas) {obj.subdatas[s] = addsubdatas(data.subtitle2);}
                }
                else {
                    obj[s] = 0;
                    if (addsubdatas) {obj.subdatas[s] = "";}
                }
            });
            result.push(obj);
            curDate = this.addDays(curDate, 1);
        }
        const obj = {
            results: result,
            subsections: subsections
        };
        return obj;
    }
    getCallByDayOfWeekArray(arrayDates) {
        const subsection = "Appels";
        const result = [];
        const subsections = [subsection];

        const week = [{ day: strings.monday, value: 2 }, { day: strings.tuesday, value: 3 }, { day: strings.wednesday, value: 4 }, { day: strings.thursday, value: 5 }, { day: strings.friday, value: 6 }, { day: strings.saturday, value: 7 }, { day: strings.sunday, value: 1 }];
        week.forEach(dow => {
            const dayData = arrayDates.find(d => d.name === dow.value.toString());
            const newr = {
                name: dow.day,
                short: dow.day
            };
            newr[subsection] = dayData ? dayData.count : 0;
            result.push(newr);
        });

        const obj = {
            results: result,
            subsections: subsections
        };
        return obj;
    }
    getCallByHourOfDayArray(darrayDates) {
        const subsection = "Appels";
        const result = [];
        const subsections = [subsection];

        const arrayDates = [];
        darrayDates.forEach(hour => {
            const date = new Date();
            if (hour.subtitle.toString() === "120") {
                //on est à l'heure d'été
                date.setMonth(7);
            }
            else {
                date.setMonth(0);
            }
            date.setUTCHours(Number(hour.name));
            const newName = date.getHours().toString();
            const curHour = arrayDates.find(h => h.name === newName);
            if (curHour) {
                curHour.count += hour.count;
            }
            else {
                arrayDates.push({ ...hour, name: newName });
            }
        });

        for (let i = arrayDates.length > 0 ? Number(arrayDates[0].name) : 8; i <= (arrayDates.length > 0 ? Number(arrayDates[arrayDates.length - 1].name) : 18); i++ ) {
            const hData = arrayDates.find(d => d.name === i.toString());
            const newr = {
                name: String(i).padStart(2, "0") + "h",
                short: String(i).padStart(2, "0") + "h"
            };
            newr[subsection] = hData ? hData.count : 0;
            result.push(newr);
        }

        const obj = {
            results: result,
            subsections: subsections
        };
        return obj;
    }
    dateUTCToLocal(dateString) {
        // Convert string to UTC date object
        const date = new Date(dateString + " UTC"); // exemple:Mon Jun 24 2024 11:59:12 GMT+0200

        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // Get componants of UTC date
        const utcDay = date.getUTCDay();
        const utcDate = date.getUTCDate();
        const utcMonth = date.getUTCMonth();
        const utcYear = date.getUTCFullYear();
        const utcHours = date.getUTCHours();
        const utcMinutes = date.getUTCMinutes();
        const utcSeconds = date.getUTCSeconds();

        const UTCDateFormatted = `${days[utcDay]}, ${String(utcDate).padStart(2, "0")} ${months[utcMonth]} ${utcYear} ${String(utcHours).padStart(2, "0")}:${String(utcMinutes).padStart(2, "0")}:${String(utcSeconds).padStart(2, "0")} GMT`;

        // Convert string to date object
        const DateUTC = new Date(UTCDateFormatted);

        // Get componants of local date
        const year = DateUTC.getFullYear();
        const month = String(DateUTC.getMonth() + 1).padStart(2, "0");
        const day = String(DateUTC.getDate()).padStart(2, "0");
        const hours = String(DateUTC.getHours()).padStart(2, "0");
        const minutes = String(DateUTC.getMinutes()).padStart(2, "0");
        const seconds = String(DateUTC.getSeconds()).padStart(2, "0");

        // Format date to format "yyyy-MM-dd HH:mm:ss"
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        return formattedDate;
    }

    getContinuousDatesArray(statecontinuouscallSessions) {
        if (!statecontinuouscallSessions) {return null;}
        // Clone statecontinuouscallSessions before modify
        const continuouscallSessions = JSON.parse(JSON.stringify(statecontinuouscallSessions));
        continuouscallSessions.forEach(cs => {
            cs.dateStart = this.dateUTCToLocal(cs.dateStart);
            cs.dateEnd = this.dateUTCToLocal(cs.dateEnd);
        });
        return continuouscallSessions;
    }

    getTreesArray(arrayTrees) {
        let result = [];
        arrayTrees.forEach(at => {
            let name = strings.NotSpecified;
            if (at.name && at.name !== "") {
                const split = at.name.split("#");
                name = split[split.length - 1];
            }
            result.push({ name: name, count: at.count });
        });
        result = result.sort((a, b) => a.count - b.count);
        return result;
    }
    getDurationText(secs) {
        const hour = Math.floor(secs / 3600);
        const min = Math.floor((secs - hour * 3600) / 60);
        const sec = Math.floor(secs - hour * 3600 - min * 60);
        if (hour > 0) {
            return hour + "h" + String(min).padStart(2, "0");
        }
        else {
            return min + "'" + String(sec).padStart(2, "0");
        }
    }
    getWaitingSum(list) {
        if (!list) {return 0;}
        let tot = 0;
        list.forEach(l => tot += l.count);
        return tot;
    }

    render() {
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}
                onGetElements={
                    (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                        this.GetNewReporting(
                            this.props.dateSelected["Start date"],
                            this.props.dateSelected["End date"],
                            this.props.zoneSelected ? this.props.zoneSelected.id : null,
                            this.props.callcenterSelected ? this.props.callcenterSelected.id : null,
                            (data) => {
                                const result = {
                                    pageNumber: pageNumber,
                                    pageSize: 1000,
                                    sortExpression: sortExpression,
                                    filterExpression: filterExpression,
                                    tagSearchRequest: tagSearchRequest,
                                    PaginationType: this.props.administration.paginationtypewebcall ? this.props.administration.paginationtypewebcall : PaginationType,
                                    results: data ? data : []
                                };
                                onSuccess(data ? result : null);
                                this.setState({ listResults: result });
                            }
                        );
                    }
                }
                onSavePagination={(paginationType) => {
                    //this.props.EditPaginationListType("webcall", paginationType);
                    this.setState({ listResults: { ...this.state.listResults, PaginationType: paginationType } });
                }}
                myElements={{ ...this.state.listResults,
                    PaginationType:
                    //this.props.administration && this.props.administration.paginationtypewebcall ? this.props.administration.paginationtypewebcall :
                    this.state.listResults ? this.state.listResults.PaginationType : null
                }}

                tableElement={(element, onReloadList) => {
                    return [
                        {
                            colTitle: strings.IntercomName,
                            fixedWidth: "220px",
                            colContent: element && element.name ? element.name : null
                        },
                        {
                            colTitle: strings.Description,
                            fixedWidth: "220px",
                            colContent: element && element.description ? element.description : null
                        },
                        {
                            colTitle: strings.TotalCall,
                            fixedWidth: "150px",
                            lockWidth: true,
                            justify: "center",
                            colContent: element ? element.callCount : 0
                        },
                        {
                            colTitle: strings.callHandledCardTitle,
                            fixedWidth: "130px",
                            lockWidth: true,
                            justify: "center",
                            colContent: element ? element.successCount : 0
                        },
                        {
                            colTitle: strings.callLostCardTitle,
                            fixedWidth: "150px",
                            lockWidth: true,
                            justify: "center",
                            colContent: element ? element.interruptionCount : 0
                        },
                        {
                            colTitle: strings.availability,
                            fixedWidth: "200px",
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value) {
                                    const percent = value.totalDisponibility > 0 ? Math.round(value.availableTime * 100 / value.totalDisponibility) : 0;
                                    const minutes = Math.trunc(value.availableTime / 60);
                                    const hours = Math.trunc(minutes / 60);
                                    return <div style={{ display: "flex", flexDirection: "row", gap: "8px",
                                        justifyContent: "flex-start" }}
                                    >
                                        <p style={{ color: percent <= 50 ? "#FF002E" : "#00C45B" }}>{percent + "%"}</p>
                                        <p>·</p>
                                        <p>{(hours > 0 ? hours + " h " : "") + (minutes - hours * 60) + " min"}</p>
                                    </div>;
                                }
                                else {return "";}
                            },
                            colContent: element ? {
                                totalDisponibility: element.totalDisponibility,
                                availableTime: element.availableTime
                            } : null
                        },
                        {
                            colTitle: strings.SatisfactionClientAverage,
                            fixedWidth: "200px",
                            lockWidth: true,
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value) {
                                    return <div className="bloc-stars" style={{ display: "flex", flexDirection: "row", gap: "4px", padding: "0 10px",
                                        justifyContent: "flex-end", opacity: value.noteClient ? "1" : "0.25" }}>
                                        {
                                            [1, 2, 3, 4, 5].map((ar, index) => {
                                                const note = value.noteClient && Number(value.noteClient) === 0 ? 1 : Number(value.noteClient);
                                                return (
                                                    <IconComponent
                                                        key={index}
                                                        nameIcon="star"
                                                        dimensions="20"
                                                        fill={true}
                                                        color={note < ar ? "grey-light" : "carbone"}
                                                    />
                                                );
                                            })
                                        }
                                    </div>;
                                }
                                else {return "";}
                            },
                            colContent: element ? {
                                noteClient: element.avgReviews
                            } : null
                        },
                        {
                            colTitle: "",
                            colType: "actions",
                            actions: [0],
                            colContent: [
                                <ButtonSkaRound
                                    key={"dots"}
                                    type="primary"
                                    onClick={() => {
                                        this.GetNewReportingForAgent(element.id, element.name);
                                    }}
                                    nameIcon="dots"
                                />
                            ]
                        }
                    ];
                }}
            />
            <Drawer open={this.state.results}
                onClose={() => this.setState({ results: null })}
                title={this.state.results ? "Dashboard / " + this.state.results.name : "Dashboard"}
            >
                {this.state.results && this.state.results.state === "loading" ? <div className="loader-container" style={{ height: "100%" }}>
                    <Loader dimensions="40px" color={"var(--primary-base)"} />
                </div> :
                    !this.state.results || !this.state.results.data ? null : <>
                        <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                            <CardReporting
                                background={true}
                                resultType="number"
                                flex={1}
                                textPill={"Total des appels".toUpperCase()}
                                resultReport={(this.state.results.data.countNominalcallSuccess
                                    + this.state.results.data.countNominalcallFail
                                    + this.state.results.data.countNominalcallUnavailable)}
                            />
                            <CardReporting
                                background={true}
                                resultType="number"
                                flex={1}
                                textPill={"Appels Traités".toUpperCase()}
                                resultReport={(this.state.results.data.countNominalcallSuccess)}
                            />
                        </div>
                        <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                            <CardReporting
                                background={true}
                                resultType="number"
                                flex={1}
                                textPill={"Appels Perdus".toUpperCase()}
                                resultReport={(this.state.results.data.countNominalcallFail)}
                            />
                        </div>
                        {/*<div className="horizontalFlexContainer" style={{gap": "20px" }}>
                            // this one is independant from AgentId
                            <CardReporting
                                background={true}
                                resultType="popularQueries"
                                flex={2}
                                textPill={strings.Categories.toUpperCase()}
                                resultReport={this.getTreesArray(this.state.results.data.callsCategories)}
                                textPill2={strings.Sujets.toUpperCase()}
                                resultReport2={this.getTreesArray(this.state.results.data.nominalcallQuestions)}
                            />
                        </div>*/}
                        <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                            <CardReporting
                                background={true}
                                resultType="notation"
                                flex={2}
                                textPill={strings.satisfactionClient.toUpperCase()}
                                resultReport={this.getNotesArray(this.state.results.data.nominalcallReview, this.state.results.data.countNominalcallSuccess)}
                            />
                        </div>
                        <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                            <CardReporting
                                resultType="graph"
                                background={true}
                                flex={2}
                                textPill={strings.Jours.toUpperCase()}
                                textPill2={strings.Timings.toUpperCase()}
                                resultReport={this.getCallByDayOfWeekArray(this.state.results.data.nominalcallbyDayofweek)}
                                resultReport2={this.getCallByHourOfDayArray(this.state.results.data.nominalcallbyHourofday)}
                                infosReportTopRight = {strings.DistributionOf + " " + (this.state.results.data.countNominalcallSuccess + this.state.results.data.countNominalcallFail) + " " + strings.weekdayCalls}
                                infosReportTopRight2 = {strings.DistributionOf + " " + (this.state.results.data.countNominalcallSuccess + this.state.results.data.countNominalcallFail) + " " + strings.byTimeSlots}
                            />
                        </div>
                        {/*<div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                            // this one is independant from AgentId
                            <CardReporting
                                resultType="graph"
                                background={true}
                                flex={2}
                                textPill={strings.WaitingList.toUpperCase()}
                                resultReport={this.getDatesArray(this.state.results.data.waitingListDates, (mean) => {
                                    const min = Math.floor(mean / 60);
                                    const sec = mean - min * 60;
                                    return " - Moy. " + min + "'" + String(sec).padStart(2, "0");
                                })}
                                textTooltip={strings.personsWaiting}
                                infosReportTopRight = {strings.TotalNumberOfPeopleWaiting + " : "
                                    + (this.state.results.data.waitingListDates ? this.getWaitingSum(this.state.results.data.waitingListDates) : 0)
                                }
                            />

                        </div>*/}
                        <div className={classNames("verticalFlexContainer")} style={{
                            gap: "20px",
                            width: "calc(100% - 40px)",
                            alignItems: "center",
                            padding: "20px",
                            borderRadius: "6px",
                            background: "#D1D4DC"
                        }}>
                            <div className={classNames("TextHeader32", "w700")} >
                                {strings.DisturbedSituations}
                            </div>
                            <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                                <CardReporting
                                    resultType="number"
                                    flex={1}
                                    textPill={strings.ContinuousModeTransitions.toUpperCase()}
                                    resultReport={this.state.results.data.continuouscallSessions.length + "x"}
                                    infosReport={strings.OverThePeriod}
                                />
                            </div>
                            <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                                <CardReporting
                                    resultType="eventsdates"
                                    flex={2}
                                    textPill={strings.ListOfEvents.toUpperCase()}
                                    resultReport={this.getContinuousDatesArray(this.state.results.data.continuouscallSessions)}
                                />
                            </div>
                            <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                                <CardReporting
                                    resultType="notation"
                                    flex={1}
                                    textPill={strings.satisfactionClient.toUpperCase()}
                                    resultReport={this.getNotesArray(this.state.results.data.continuouscallReview, null)}
                                />
                            </div>
                        </div>
                    </>}
            </Drawer>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(DashboardAgents);
